import React, { useState } from "react";
import {
  Container, Typography, TextField, Button, MenuItem,
  Card, CardContent, CircularProgress, Alert, FormControlLabel, Checkbox, Link
} from "@mui/material";
import "./ApplyNow.css";

const ApplyNow = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    loanType: "",
    amount: "",
    message: "",
  });

  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", text: "" });
  const [consentError, setConsentError] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", text: "" });
    setConsentError(false);

    if (!consent) {
      setConsentError(true);
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("https://core-bankers-backend.vercel.app/apply-now", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({ type: "success", text: data.message || "Submitted successfully! we will get in touch within 24hrs" });
        setFormData({ name: "", mobile: "", loanType: "", amount: "", message: "" });
        setConsent(false);
      } else {
        setStatus({ type: "error", text: data.message || "Something went wrong." });
      }
    } catch (error) {
      setStatus({ type: "error", text: "Server error. Please try again later." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs" className="apply-form-wrapper">
      <Card className="apply-form-card">
        <CardContent>
          <Typography variant="h5" className="form-title">
        Apply for Loan
      </Typography>
          <form onSubmit={handleSubmit} className="apply-form">
            <TextField
              label="Full Name"
              name="name"
              fullWidth
              required
              value={formData.name}
              onChange={handleChange}
              className="form-field"
            />
            <TextField
              label="Mobile Number"
              name="mobile"
              fullWidth
              required
              value={formData.mobile}
              onChange={handleChange}
              className="form-field"
            />
            <TextField
              label="Required Amount (₹)"
              name="amount"
              fullWidth
              required
              value={formData.amount}
              onChange={handleChange}
              className="form-field"
            />
            <TextField
              select
              label="Loan Type"
              name="loanType"
              fullWidth
              required
              value={formData.loanType}
              onChange={handleChange}
              className="form-field"
            >
              {["Personal", "Business", "Vehicle", "Home"].map((type) => (
                <MenuItem key={type} value={type}>
                  {type} Loan
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label="Message (Optional)"
              name="message"
              fullWidth
              multiline
              rows={3}
              value={formData.message}
              onChange={handleChange}
              className="form-field"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                  color="primary"
                />
              }
              label={
                <Typography variant="body2">
                  I authorise to send messages via SMS, WhatsApp, RCS, and other as per{" "}
                  <Link href="/consent-policy" target="_blank" rel="noopener noreferrer">Consent Policy</Link>,{" "}
                  <Link href="/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link> and{" "}
                  <Link href="/privacy" target="_blank" rel="noopener noreferrer">Privacy policy</Link>.
                </Typography>
              }
              sx={{ mt: 1 }}
            />

            {consentError && (
              <Alert severity="warning" sx={{ mt: 1 }}>
                Please provide consent before submitting the form.
              </Alert>
            )}

            <div className="submit-area">
              <Button
                type="submit"
                variant="contained"
                fullWidth
                className="submit-button"
                disabled={loading}
              >
                {loading ? <CircularProgress size={22} color="inherit" /> : "Submit"}
              </Button>

              {status.text && (
                <Alert
                  severity={status.type}
                  style={{ marginTop: "16px", fontSize: "0.95rem" }}
                >
                  {status.text}
                </Alert>
              )}
            </div>
          </form>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ApplyNow;